import React from 'react';
import PropTypes from 'prop-types';
import { DetailPanelData } from "../Common/DetailPanel"
import { formatSQLDateTime } from '../../utils';

const BlowbackPreventer = ({
    data: {
        assetTypeId = null,
        backflowPreventerTypeName = '',
        backflowPreventerTypeOrientation = '',
        backflowPreventerTypeShutoffValve = '',
        backflowPreventerTypeWaterOrigin = '',
        backflowPreventerTypeInstallationDate = '',
    } = {}
}) => {
    if (assetTypeId !== 20) return null;
return (
    <>
        <DetailPanelData id='BackflowTypeHeader' title="BACKFLOW TYPE" data={backflowPreventerTypeName}  />
        <DetailPanelData id='BackflowOrientationHeader' title="BACKFLOW ORIENTATION" data={backflowPreventerTypeOrientation}  />
        <DetailPanelData id='BackflowShutoffValveHeader' title="BACKFLOW SHUTOFF VALVE" data={backflowPreventerTypeShutoffValve}  />
        <DetailPanelData id='WaterOriginHeader' title="WATER ORIGIN" data={backflowPreventerTypeWaterOrigin}  />
        <DetailPanelData id='InstallationDateHeader' title="INSTALLATION DATE" data={formatSQLDateTime(backflowPreventerTypeInstallationDate)}  />
    </>
    );
};

BlowbackPreventer.propTypes = {
    data: PropTypes.object.isRequired
};

export default BlowbackPreventer;